import React from 'react'
import PropTypes from 'prop-types'
import GSAP from 'react-gsap-enhancer'

import {
  Message,
  MessageAgent,
  MessageJoinLeave,
  MessageSystem,
  MessageUser,
  MessageNewPushPageUrl,
  MessageAgentFileTransfer,
} from '../components'
import CustomPills from '../../CustomPills'

class MessageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show: true,
    }
  }

  static propTypes = {
    text: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    fileInfo: PropTypes.shape({
      size: PropTypes.string,
      address: PropTypes.string,
    }),
    masked: PropTypes.bool,
    type: PropTypes.oneOf([
      'user',
      'agent',
      'system',
      'join',
      'leave',
      'newPushPageUrl',
      'imageTransfer',
      'fileTransfer',
    ]).isRequired,
  }

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.text !== this.props.text ||
      nextProps.type !== this.props.type ||
      nextProps.stage !== this.props.stage
    ) {
      return true
    }

    return false
  }

  handleSubmit = (input) => {
    const {
      onValidationError,
      onSubmit,
      currentQuestion: { regex: { pattern, flags } = {} },
      selected,
      complexChange,
    } = this.props

    if (pattern) {
      const regex = new RegExp(pattern, flags)
      if (!regex.test(input.value)) {
        return onValidationError()
      }
    }
    this.setState({ show: false })
    complexChange(true)
    input && typeof input === 'object' && selected(input.id)
    this.forceUpdate()
    return onSubmit(input)
  }

  render() {
    const { type } = this.props

    const User = Message(MessageUser)
    const System = Message(MessageSystem)
    const Agent = Message(MessageAgent)
    const JoinLeave = Message(MessageJoinLeave)
    const NewPushPageUrl = Message(MessageNewPushPageUrl)
    const FileTransfer = Message(MessageAgentFileTransfer)

    return (
      <React.Fragment>
        {type === 'user' && <User {...this.props} />}

        {type === 'system' && <System {...this.props} />}

        {type === 'agent' && <Agent {...this.props} />}

        {type === 'newPushPageUrl' && <NewPushPageUrl {...this.props} />}

        {type === 'join' || type === 'leave' ? <JoinLeave {...this.props} /> : null}

        {type === 'imageTransfer' || type === 'fileTransfer' ? <FileTransfer {...this.props} /> : null}
        {this.props.currentQuestion && this.props.currentQuestion.options && (
          <div className='lc-message lc-message--user'>
            {this.props.currentQuestion.selected && <p className='lc-message__body'>Selected</p>}
            <div className={`${this.props.currentQuestion.options.length >= 3 ? 'pills' : 'pill'}`}>
              {!this.props.currentQuestion.selected &&
                this.props.currentQuestion.options.map((option, idx) => (
                  <CustomPills
                    key={option.value}
                    value={option.value}
                    onSubmit={this.handleSubmit}
                    index={idx}
                    id={this.props.currentQuestion.id}
                    options={this.props.currentQuestion.options}
                  />
                ))}
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

export { MessageContainer }

export default GSAP()(MessageContainer)
